import { WidgetProps } from '@rjsf/utils';
import { Grid, MenuItem } from '@mui/material';
import Fieldset from '@/components/_common/Fieldset';
import DropdownSelect from '@/components/_common/Form/DropdownSelect';
import MediaBox from '../MediaBox';

const MediaWidget = (props: WidgetProps) => {
  const { onChange, required, value, label, options } = props;

  if (props.readonly) return <MediaBox value={value} />;

  return (
    <Grid container>
      <Grid item sm={6}>
        <Fieldset label="Media" color="primary">
          <Grid container spacing={2} mt={0}>
            <Grid item sm={8}>
              <DropdownSelect
                label={label}
                name="media_resolution"
                fullWidth
                onChange={(newValue) => onChange(newValue)}
                value={value}
                required={required}
              >
                <MenuItem value="">-</MenuItem>
                {options.enumOptions?.map(({ label, value: optValue }) => (
                  <MenuItem key={optValue} value={optValue}>
                    {label}
                  </MenuItem>
                ))}
              </DropdownSelect>
            </Grid>
          </Grid>
        </Fieldset>
      </Grid>
    </Grid>
  );
};

export default MediaWidget;
